var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reFresh)?_c('div',{staticStyle:{"width":"100%","height":"45vh"},attrs:{"id":"chart"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }